import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//API
// import ItemService from "../../../services/customer_appCommonService";
import { Form, Table } from 'react-bootstrap';

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import {
    validateName,
    validPostalCode,
} from "../../../common/Validations";
// import toast from "react-hot-toast";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
// import { saveCustomerRegData } from "../../../redux/feature/customer_app/customerV1Slice";
import Layout from "../../../Layout/Layout";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";

const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
        "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
        "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
        "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
    GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const PreAssesmentForm = () => {

    localStorage.setItem("menu", "");
    localStorage.setItem("submenu", "");
    let userData = useSelector((state) => state?.user?.data);


    let factoryTypeOptions = [
        {
            id: "1",
            name: "Factory",
        },
        {
            id: "2",
            name: "EnterPrises",
        },
    ];
    let buildingTypeOptions = [
        {
            id: "1",
            name: "Shared",
        },
        {
            id: "2",
            name: "Self Occupied",
        },
    ];

    let sewageTreatmentOptions = [
        {
            id: "1",
            name: "Recycled and Reused in the Factory",
        },
        {
            id: "2",
            name: "Treated and Discharged outside",
        },
        {
            id: "3",
            name: "Reused for Garden",
        },
        {
            id: "4",
            name: "Others",
        },
    ];
    let sewageTreatmentOptionsFalse = [
        {
            id: "1",
            name: "Discharge to Public Sewer",
        },
        {
            id: "2",
            name: "Disposed to Private treatment Plant",
        },
        {
            id: "3",
            name: "Sent to Septic Tank",
        },
        {
            id: "4",
            name: "Others",
        },
    ];
    let relationship = [
        {
            id: "1",
            name: "Joint Venture",
        },
        {
            id: "2",
            name: "Owned",
        },
        {
            id: "3",
            name: "Service Provider",
        },
    ];

    /* pop failure modal */
    const failureModalData = {
        title: "Warning",
        ErrorMsg: "",
    };

    // let requiredFields = [];

    const [getDropdownData, setDropdownData] = useState("");
    const [isCardVisible, setCardVisible] = useState(true);
    const [isCardVisible2, setCardVisible2] = useState(true);
    const [isCardVisible3, setCardVisible3] = useState(true);
    const [getFailureModal] = useState(failureModalData);
    const [getShowFailureModal, setShowFailureModal] = useState(false);
    const [getErrorFields, /*setErrorFields*/] = useState([]);
    const [getUtilites, setUtilites] = useState([
        {
            id: Date.now(),
            relationShip: "",
            fullAddress: "",
            facilityName: "",
            subContractedProcess: "",

        },
    ]);
    //Utilites
    const deleteUtilites = (id) => {
        const updatedData1 = getUtilites.filter(
            (doc) => doc.id !== id
        );
        setUtilites(updatedData1);
    };
    const addUtilites = () => {
        const newDocument = {
            id: Date.now(),
            relationShip: "",
            fullAddress: "",
            facilityName: "",
            subContractedProcess: "",
        };
        setUtilites((prevData) => [...prevData, newDocument]);
    };

    const [otherSources, setOtherSources] = useState([
        { id: Date.now(), value: "" }
    ]);

    const handleOtherSourceChange = (index, e) => {
        const { name, value } = e.target;
        const updated = [...otherSources];
        updated[index][name] = value;
        setOtherSources(updated);
    };

    const handleUtilites = (id, fieldName, value) => {
        let error = "";

        setUtilites((prevData) =>
            prevData.map((doc) =>
                doc.id === id ? { ...doc, [fieldName]: value } : doc
            )
        );
        // Update validation with unique key per row
        if (fieldName === "Quantity") {
            setValidation((prev) => ({
                ...prev,
                [`${id}Quantity`]: error,  // <-- unique key here
            }));
        }
    };
    const [validation, setValidation] = useState({
        organisationName: "",
        routeNumber: "",
        commission: "Yes",
        commissionRate: "",
    });
    const toggleCardVisibility = () => {
        setCardVisible(!isCardVisible);
    };
    const toggleCardVisibility2 = () => {
        setCardVisible2(!isCardVisible2);
    };
    const toggleCardVisibility3 = () => {
        setCardVisible3(!isCardVisible3);
    };
    const onInputChange = ({ target: { name, value, type, checked } }) => {
        const errors = {};
        setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
        setFormInputs((formInputs) => ({
            ...formInputs,
            [name]: type === "checkbox" ? checked : value,
        }));
        validateName(name === "organisationName" ? value : "")
            ? (errors.organisationName = "")
            : (errors.organisationName = message.VALID_CUSTOMER_NAME);
        validPostalCode(name === "cityPostalCode" ? value : "")
            ? (errors.cityPostalCode = "")
            : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

        setValidation((prev) => ({
            ...prev,
            [name]: errors[name] || "",
        }));
    };

    const [formInputs, setFormInputs] = useState({
        createdBy: userData?.userId || "",
        auditType: "",
        thirdPartyValidDate: "",
        thirdPartyDoc: "",
        legalVendorName: "",
        vendorAddress: "",
        factoryType: "",
        legalFactoryName: "",
        factoryAdress: "",
        factoryContactName: "",
        telephoneNumber: "",
        buildingType: "",
        establishmentDate: "",
        otherRvindhFashonsBrands: "",
        noOfProductionShifts: "",
        noOfBuildings: "",
        higgindexFem: "",
        indexFslm: "",
        factoryLicense: "",
        licenseUpload: "",
        validTillSpcb: "",
        validThirdPartyReports: "",
        factoryLayoutApproved: "",
        capacity: "",
        source: "",
        othersSource: "",
        totalElectricConsumption: "",
        sewageTreatment: "",
        sewageTreatmentOptions: "",
        selfAssesmentScore: "",
        othersewageTreatment: "",
        treatmentPlant: "",
        paperwasteQty: "",
        polyBagwasteQty: "",
        cartonBoxwasteQty: "",
        chindiWaste: "",
        eWaste: "",
        usedOil: "",
        emptyChemicalQty: "",
        etpSludgeQty: "",
        cartonBoxWasteQty2: "",
        chindiWaste2: "",
        polyBagWasteQty2: "",
        paperwasteQty2: "",
        subContracted: "",
        facilityName: "",
        fullAddress: "",
        verifiedScore: "",
        permanentMaleCount: "",
        permanentFemaleCount: "",
        totalPeramnentCount: "",
        contractMaleCount: "",
        contractFemaleCount: "",
        contractTotalCount: "",
        pieceRateWorkerMaleCount: "",
        pieceRateWorkerFemaleCount: "",
        pieceRateWorkerTotalCount: "",
        probationaryMaleCount: "",
        probationaryFemaleCount: "",
        probationaryTotalCount: "",
        totalFemaleCount: "",
        totalMaleCount: "",
        totalCount: "",
        fslsselfAssScore: "",
        fslsverifiedScore: "",
        validTillLicence: "",
        thirdPartyName: "",
        thirdPartyDesc: "",
    });

    const {
        permanentMaleCount, permanentFemaleCount,
        contractMaleCount, contractFemaleCount,
        pieceRateWorkerMaleCount, pieceRateWorkerFemaleCount,
        probationaryMaleCount, probationaryFemaleCount,
    } = formInputs;

    // Convert string inputs to numbers for calculations
    const parseNum = (value) => Number(value) || 0;

    const permanentMale = parseNum(permanentMaleCount);
    const permanentFemale = parseNum(permanentFemaleCount);
    const contractMale = parseNum(contractMaleCount);
    const contractFemale = parseNum(contractFemaleCount);
    const pieceRateWorkerMale = parseNum(pieceRateWorkerMaleCount);
    const pieceRateWorkerFemale = parseNum(pieceRateWorkerFemaleCount);
    const probationaryMale = parseNum(probationaryMaleCount);
    const probationaryFemale = parseNum(probationaryFemaleCount);

    useEffect(() => {
        const calculatedTotal = permanentMaleCount + permanentFemaleCount;
        setFormInputs(prev => ({
            ...prev,
            totalPeramnentCount: isNaN(calculatedTotal) ? '' : String(calculatedTotal)
        }));
    }, [permanentMaleCount, permanentFemaleCount]);
    // Permanent Employees Total
    useEffect(() => {
        const calculatedTotal = permanentMale + permanentFemale;
        setFormInputs(prev => ({
            ...prev,
            totalPeramnentCount: isNaN(calculatedTotal) ? '' : String(calculatedTotal)
        }));
    }, [permanentMale, permanentFemale]);

    // Contract Workers Total
    useEffect(() => {
        const calculatedTotal = contractMale + contractFemale;
        setFormInputs(prev => ({
            ...prev,
            contractTotalCount: isNaN(calculatedTotal) ? '' : String(calculatedTotal)
        }));
    }, [contractMale, contractFemale]);

    // Piece Rate Workers Total
    useEffect(() => {
        const calculatedTotal = pieceRateWorkerMale + pieceRateWorkerFemale;
        setFormInputs(prev => ({
            ...prev,
            pieceRateWorkerTotalCount: isNaN(calculatedTotal) ? '' : String(calculatedTotal)
        }));
    }, [pieceRateWorkerMale, pieceRateWorkerFemale]);

    // Probationary Total
    useEffect(() => {
        const calculatedTotal = probationaryMale + probationaryFemale;
        setFormInputs(prev => ({
            ...prev,
            probationaryTotalCount: isNaN(calculatedTotal) ? '' : String(calculatedTotal)
        }));
    }, [probationaryMale, probationaryFemale]);

    // Overall Male Total
    useEffect(() => {
        const overallMale = permanentMale + contractMale + pieceRateWorkerMale + probationaryMale;
        setFormInputs(prev => ({
            ...prev,
            totalMaleCount: isNaN(overallMale) ? '' : String(overallMale)
        }));
    }, [permanentMale, contractMale, pieceRateWorkerMale, probationaryMale]);

    // Overall Female Total
    useEffect(() => {
        const overallFemale = permanentFemale + contractFemale + pieceRateWorkerFemale + probationaryFemale;
        setFormInputs(prev => ({
            ...prev,
            totalFemaleCount: isNaN(overallFemale) ? '' : String(overallFemale)
        }));
    }, [permanentFemale, contractFemale, pieceRateWorkerFemale, probationaryFemale]);

    // Grand Total of All Employees
    useEffect(() => {
        const grandTotal = permanentMale + permanentFemale +
            contractMale + contractFemale +
            pieceRateWorkerMale + pieceRateWorkerFemale +
            probationaryMale + probationaryFemale;
        setFormInputs(prev => ({
            ...prev,
            totalCount: isNaN(grandTotal) ? '' : String(grandTotal)
        }));
    }, [
        permanentMale, permanentFemale,
        contractMale, contractFemale,
        pieceRateWorkerMale, pieceRateWorkerFemale,
        probationaryMale, probationaryFemale
    ]);

    useEffect(() => {
        if (getDropdownData?.codeType === "country") {
            setFormInputs((formInputs) => ({
                ...formInputs,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,

            }));
        } else {
            setFormInputs((formInputs) => ({
                ...formInputs,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
            }));
        }
        setValidation((prev) => ({
            ...prev,
            [getDropdownData?.textField]: "",
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDropdownData]);

    const hideFailureModal = () => {
        setShowFailureModal(false);
    };

    // file attachmetns
    const onSuccessUploadfiles = (data) => {
        setFormInputs((prevData) => ({
            ...prevData,
            [data.fieldName]: data.attachmentId,
        }));
    };
    // View attachment files
    const [getShowFileViewModal, setShowFileViewModal] = useState(false);
    const [getFileViewData, setFileViewData] = useState(null);

    const handleViewFile = (fileAttachmentId) => {
        setFileViewData(fileAttachmentId);
        setShowFileViewModal(true);
    };
    const handleViewFileHide = () => {
        setShowFileViewModal(false);
    };

    const [categories, setCategories] = useState([
        { name: "T-shirt", capacity: 0, selected: false },
        { name: "Trouser", capacity: 0, selected: false },
        { name: "waist Coat", capacity: 0, selected: false },
        { name: "Shorts", capacity: 0, selected: false },
        { name: "Blazer", capacity: 0, selected: false },
    ]);

    const handleCategoriesChange = (index, field, value) => {
        const updated = [...categories];
        updated[index][field] = field === "capacity" ? Number(value) : value;
        setCategories(updated);
    };

    const [source, setSource] = useState([
        { name: 'Ground water', capacity: 0, selected: false },
        { name: 'Municipal supply', capacity: 0, selected: false },
        { name: 'Tanker supply', capacity: 0, selected: false },
        { name: 'Surface Water', capacity: 0, selected: false },
        { name: 'Waste water', capacity: 0, selected: false },
    ]);

    const handleSourceChange = (index, field, value) => {
        const updated = [...source];
        updated[index][field] = field === 'capacity' ? Number(value) : value;
        setSource(updated);
    };
    const [renewableSource, setRenewableSource] = useState([
        { name: 'Solar', capacity: 0, selected: false },
        { name: 'Wind', capacity: 0, selected: false },
        { name: 'Hydroelectricity', capacity: 0, selected: false },
        { name: 'Bio-Mass', capacity: 0, selected: false },
        { name: 'Geothermal', capacity: 0, selected: false },
        { name: 'No', capacity: 0, selected: false },
    ]);
    const handleRenewableChange = (index, field, value) => {
        const updated = [...renewableSource];
        updated[index][field] = field === 'capacity' ? Number(value) : value;
        setRenewableSource(updated);
    };
    const [brands, /*setBrands*/] = useState([
        { name: 'ARROW', selected: true },
    ]);
    return (
        <main className="dashboard main" id="main">
            <Layout />
            <Row className="justify-center subContent">
                <Col xs={12} md={12} className="rightSide">
                    <div className="rightSideInner PageCommonCSS">
                        <h2 className="mainTitle">PreAssesment Details Form</h2>
                        <p className="subText">
                            PreAssesMent Details Form
                        </p>
                        <hr />
                        <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                            <i
                                                className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                                                    }`}
                                                onClick={toggleCardVisibility}
                                            ></i>
                                        </Col>
                                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                            <span className="iconLogo">BD</span>
                                        </Col>
                                        <Col xs={8} md={8} lg={8}>
                                            <span className="headerTitle">Basic Details</span>
                                            <span className="subHeaderTitle">Basic Details</span>
                                        </Col>
                                    </Row>
                                </h2>
                                <div
                                    className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                                        }`}
                                >
                                    <div className="accordion-body">
                                        <Row className="pt-2 pb-4">
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Legal Vendor Name"
                                                    name="legalVendorName"
                                                    placeholder=""
                                                    value={formInputs.legalVendorName || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.legalVendorName}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Vendor Address"
                                                    name="vendorAddress"
                                                    placeholder=""
                                                    value={formInputs.vendorAddress || ""}
                                                    onChange={onInputChange}
                                                    error={validation.vendorAddress}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <ComboboxField
                                                    className="inputBox"
                                                    label="Factory Type"
                                                    name="factoryType"
                                                    data={factoryTypeOptions}
                                                    placeholder=""
                                                    setValue={formInputs?.factoryType || ""}
                                                    onChange={onInputChange}
                                                    error={validation.factoryType}
                                                    getvalue={setDropdownData}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Legal Factory Name"
                                                    name="legalFactoryName"
                                                    placeholder=""
                                                    value={formInputs?.legalFactoryName || ""}
                                                    onChange={onInputChange}
                                                    error={validation.legalFactoryName}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    label="Factory Address"
                                                    placeholder=""
                                                    name="factoryAdress"
                                                    value={formInputs?.factoryAdress}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>

                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Factory Contact Name"
                                                    name="factoryContactName"
                                                    placeholder=""
                                                    value={formInputs?.factoryContactName}
                                                    onChange={onInputChange}
                                                    error={validation.factoryContactName}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Telephone Number"
                                                    name="telephoneNumber"
                                                    placeholder=""
                                                    value={formInputs?.telephoneNumber || ""}
                                                    onChange={onInputChange}
                                                    error={validation.telephoneNumber || ""}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <ComboboxField
                                                    className="inputBox"
                                                    label="Building Type"
                                                    name="buildingType"
                                                    data={buildingTypeOptions}
                                                    placeholder=""
                                                    setValue={formInputs?.buildingType || ""}
                                                    onChange={onInputChange}
                                                    error={validation.buildingType}
                                                    getvalue={setDropdownData}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Establishment date"
                                                    name="establishmentDate"
                                                    type="date"
                                                    min={2023}
                                                    placeholder=""
                                                    value={formInputs?.establishmentDate}
                                                    onChange={onInputChange}
                                                    error={validation.establishmentDate}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="What other Brands are manufactured other than Arvind Brands?"
                                                    name="otherRvindhFashonsBrands"
                                                    placeholder=""
                                                    value={formInputs?.otherRvindhFashonsBrands}
                                                    onChange={onInputChange}
                                                    error={validation.otherRvindhFashonsBrands}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="No of Production Shifts"
                                                    name="noOfProductionShifts"
                                                    placeholder=""
                                                    value={formInputs?.noOfProductionShifts}
                                                    onChange={onInputChange}
                                                    error={validation.noOfProductionShifts}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="No. of Buildings"
                                                    name="noOfBuildings"
                                                    placeholder=""
                                                    value={formInputs?.noOfBuildings}
                                                    onChange={onInputChange}
                                                    error={validation.noOfBuildings}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                            <i
                                                className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                                                    }`}
                                                onClick={toggleCardVisibility2}
                                            ></i>
                                        </Col>
                                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                            <span className="iconLogo">PD</span>
                                        </Col>
                                        <Col xs={8} md={8} lg={8}>
                                            <span className="headerTitle">Process Details</span>
                                            <span className="subHeaderTitle">License Details</span>
                                        </Col>
                                    </Row>
                                </h2>
                                <div
                                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                                        }`}
                                >
                                    <div className="accordion-body">
                                        <Row className="pt-2 pb-4">
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Is Factory Using Higg Index FEM?"
                                                    >
                                                        Is Factory Using Higg Index FEM?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="higgindexFem"
                                                        id="higgindexFem"
                                                        checked={formInputs?.higgindexFem === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.higgindexFem === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs.higgindexFem === true && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="What is the Self Assesment Score?"
                                                            name="selfAssesmentScore"
                                                            placeholder=""
                                                            value={formInputs?.selfAssesmentScore || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.selfAssesmentScore}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="What is the Verified Score?"
                                                            name="verifiedScore"
                                                            placeholder=""
                                                            value={formInputs?.verifiedScore || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.verifiedScore}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Is Factory Using Higg Index FSLM??"
                                                    >
                                                        Is Factory Using Higg Index FSLM?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="indexFslm"
                                                        id="indexFslm"
                                                        checked={formInputs?.indexFslm === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.indexFsls === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs.indexFslm === true && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="What is the Self Assesment Score?"
                                                            name="fslsselfAssScore"
                                                            placeholder=""
                                                            value={formInputs?.fslsselfAssScore || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.fslsselfAssScore}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="What is the Verified Score?"
                                                            name="fslsverifiedScore"
                                                            placeholder=""
                                                            value={formInputs?.fslsverifiedScore || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.fslsverifiedScore}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Do you have a factory license? If yes please upload a copy?"
                                                    >
                                                        Do you have a factory license? If yes please upload a copy?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="factoryLicense"
                                                        id="factoryLicense"
                                                        checked={formInputs?.factoryLicense === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.factoryLicense === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs.factoryLicense && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={3}
                                                        lg={3}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <FileUploadComponent
                                                            name="factoryLicenseDoc"
                                                            allowedTypes={[
                                                                "image/png",
                                                                "image/jpeg",
                                                                "application/pdf",
                                                            ]}
                                                            multiple={true} // Change to `false` for single file selection
                                                            onSuccessUpload={onSuccessUploadfiles}
                                                            value={formInputs?.factoryLicenseDoc || ""}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={1}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                    >
                                                        {(formInputs?.factoryLicenseDoc && (
                                                            <img
                                                                src="assets/img/newIcons/attached-file.png"
                                                                className="mt-1 attachmentIcon"
                                                                alt="attachments"
                                                                onClick={() =>
                                                                    handleViewFile(
                                                                        formInputs?.factoryLicenseDoc
                                                                    )
                                                                }
                                                                disabled={true}
                                                            />
                                                        )) ||
                                                            "--"}
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="Valid Till"
                                                            name="validTillLicence"
                                                            type="date"
                                                            placeholder=""
                                                            value={formInputs?.validTillLicence}
                                                            onChange={onInputChange}
                                                            error={validation.validTillLicence}
                                                            required={true}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={3}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <FileUploadComponent
                                                    name="licenseUpload"
                                                    label="Upload the license of Consent to operate from the State Pollution Control Board (SPCB)"
                                                    allowedTypes={[
                                                        "image/png",
                                                        "image/jpeg",
                                                        "application/pdf",
                                                    ]}
                                                    multiple={true} // Change to `false` for single file selection
                                                    onSuccessUpload={onSuccessUploadfiles}
                                                    value={formInputs?.licenseUpload || ""}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={1}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                            >
                                                {(formInputs?.licenseUpload && (
                                                    <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                            handleViewFile(
                                                                formInputs?.licenseUpload
                                                            )
                                                        }

                                                    />
                                                )) ||
                                                    "--"}
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Valid Till"
                                                    name="validTillSpcb"
                                                    type="date"
                                                    placeholder=""
                                                    value={formInputs?.validTillSpcb}
                                                    onChange={onInputChange}
                                                    error={validation.validTillSpcb}
                                                    required={true}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Do you have a valid Third Party Report? (If yes,please upload a copy)"
                                                    >
                                                        Do you have a valid Third Party Report? (If yes,please upload a copy){" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="validThirdPartyReports"
                                                        id="validThirdPartyReports"
                                                        checked={formInputs?.validThirdPartyReports === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.validThirdPartyReports === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs.validThirdPartyReports && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="Third Party Name (Ex - Bureu Veritas / SGS)"
                                                            name="thirdPartyName"
                                                            placeholder=""
                                                            value={formInputs?.thirdPartyName || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.thirdPartyName}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="Description"
                                                            name="thirdPartyDesc"
                                                            placeholder=""
                                                            value={formInputs?.thirdPartyDesc || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.thirdPartyDesc}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={3}
                                                        lg={3}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <FileUploadComponent
                                                            name="thirdPartyDoc"
                                                            allowedTypes={[
                                                                "image/png",
                                                                "image/jpeg",
                                                                "application/pdf",
                                                            ]}
                                                            multiple={true} // Change to `false` for single file selection
                                                            onSuccessUpload={onSuccessUploadfiles}
                                                            value={formInputs?.thirdPartyDoc || ""}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={1}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                                    >
                                                        {(formInputs?.thirdPartyDoc && (
                                                            <img
                                                                src="assets/img/newIcons/attached-file.png"
                                                                className="mt-1 attachmentIcon"
                                                                alt="attachments"
                                                                onClick={() =>
                                                                    handleViewFile(
                                                                        formInputs?.thirdPartyDoc
                                                                    )
                                                                }
                                                            />
                                                        )) ||
                                                            "--"}
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="Audit Type (Sedex / BSCI / WRAP / Other)"
                                                            name="auditType"
                                                            placeholder=""
                                                            value={formInputs?.auditType || ""}
                                                            onChange={onInputChange}
                                                            required={true}
                                                            error={validation.auditType}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <InputField
                                                            className="inputBox"
                                                            label="Valid Till"
                                                            name="thirdPartyValidDate"
                                                            type="date"
                                                            placeholder=""
                                                            value={formInputs?.thirdPartyValidDate}
                                                            onChange={onInputChange}
                                                            error={validation.thirdPartyValidDate}
                                                            required={true}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={3}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <FileUploadComponent
                                                    name="factoryLayoutApproved"
                                                    label="Upload Approved Factory Layout"
                                                    allowedTypes={[
                                                        "image/png",
                                                        "image/jpeg",
                                                        "application/pdf",
                                                    ]}
                                                    multiple={true} // Change to `false` for single file selection
                                                    onSuccessUpload={onSuccessUploadfiles}
                                                    value={formInputs?.factoryLayoutApproved || ""}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={1}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                                            >
                                                {(formInputs?.factoryLayoutApproved && (
                                                    <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                            handleViewFile(
                                                                formInputs?.factoryLayoutApproved
                                                            )
                                                        }
                                                    />
                                                )) ||
                                                    "--"}
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                            <i
                                                className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                                                    }`}
                                                onClick={toggleCardVisibility3}
                                            ></i>
                                        </Col>
                                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                            <span className="iconLogo">BD</span>
                                        </Col>
                                        <Col xs={8} md={8} lg={8}>
                                            <span className="headerTitle">Brand/Capacity/Capacity details</span>
                                            <span className="subHeaderTitle">Brand/Capacity/Capacity details</span>
                                        </Col>
                                    </Row>
                                </h2>
                                <div
                                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                                        }`}
                                >
                                    <div className="accordion-body">
                                        {/*  */}

                                        <Row>
                                            <Col xs={9} lg={9}>
                                                <h5 className="mb-3"><strong>Category</strong></h5>
                                                <div
                                                    className="table-responsive"
                                                    style={{
                                                        maxHeight: '450px',
                                                        overflowY: 'auto',
                                                        border: '1px solid #dee2e6',
                                                    }}
                                                >
                                                    <Table striped bordered hover size="sm" className="mb-0">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th><Form.Check type="checkbox" /></th>
                                                                <th>Category</th>
                                                                <th>Capacity (Per Month)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {categories.map((cat, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            checked={cat.selected}
                                                                            onChange={(e) => handleCategoriesChange(i, "selected", e.target.checked)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td>{cat.name}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={cat.capacity}
                                                                            className="form-control-sm"
                                                                            onChange={(e) => handleCategoriesChange(i, "capacity", e.target.value)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>

                                            {/* Brand Table – Right */}
                                            <Col xs={3} lg={3}>
                                                <strong > Brand to be manufactured for Arvind</strong>
                                                <div className="ms-3"
                                                    style={{
                                                        maxHeight: '450px',
                                                        overflow: 'auto',
                                                        border: '2px solid #ccc',
                                                    }}
                                                >
                                                    <table border="1" width="100%">
                                                        <thead style={{ position: 'sticky', top: 0, background: '#fff' }}>
                                                            <tr>
                                                                <th><input type="checkbox" /></th>
                                                                <th>Brands</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {brands.map((br, i) => (
                                                                <tr key={i}>
                                                                    <td><input type="checkbox" defaultChecked={br.selected} /></td>
                                                                    <td>{br.name}</td>
                                                                    d
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Col>
                                        </Row>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                            <i
                                                className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                                                    }`}
                                                onClick={toggleCardVisibility3}
                                            ></i>
                                        </Col>
                                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                            <span className="iconLogo">ED</span>
                                        </Col>
                                        <Col xs={8} md={8} lg={8}>
                                            <span className="headerTitle">Energy/Water/Sewage/waste generation Details</span>
                                            <span className="subHeaderTitle">Energy/Water/Sewage/waste generation Details</span>
                                        </Col>
                                    </Row>
                                </h2>
                                <div
                                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                                        }`}
                                >
                                    <div className="accordion-body">
                                        {/*  */}

                                        <Row>
                                            <Col xs={6} lg={6}>
                                                <h5 className="mb-3"><strong>What is the source of water in the factory?</strong></h5>
                                                <div
                                                    className="table-responsive"
                                                    style={{
                                                        maxHeight: '450px',
                                                        overflowY: 'auto',
                                                        border: '1px solid #dee2e6',
                                                    }}
                                                >
                                                    <Table striped bordered hover size="sm" className="mb-0">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th><Form.Check type="checkbox" /></th>
                                                                <th>Source of Water</th>
                                                                <th>KL/Month</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {source.map((cat, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            checked={cat.selected}
                                                                            onChange={(e) => handleSourceChange(i, 'selected', e.target.checked)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td>{cat.name}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={cat.capacity}
                                                                            className="form-control-sm"
                                                                            onChange={(e) => handleSourceChange(i, 'capacity', e.target.value)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                            {otherSources.map((doc, index) => (
                                                                <tr key={doc.id}>
                                                                    <td><Form.Check type="checkbox" /></td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Enter other source"
                                                                            className="form-control-sm"
                                                                            name="othersSource"
                                                                            value={doc.othersSource}
                                                                            onChange={(e) => handleOtherSourceChange(index, e)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Value"
                                                                            className="form-control-sm"
                                                                            name="othersValue"
                                                                            value={doc.othersValue}
                                                                            onChange={(e) => handleOtherSourceChange(index, e)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            {/* Brand Table – Right */}
                                            <Col xs={6} lg={6}>
                                                <h5 className="mb-3"><strong>% of electricity from renewable sources (kWh)</strong></h5>
                                                <div
                                                    className="table-responsive"
                                                    style={{
                                                        maxHeight: '450px',
                                                        overflowY: 'auto',
                                                        border: '1px solid #dee2e6',
                                                    }}
                                                >
                                                    <Table striped bordered hover size="sm" className="mb-0">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th><Form.Check type="checkbox" /></th>
                                                                <th>Renewable</th>
                                                                <th>%</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {renewableSource.map((cat, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            checked={cat.selected}
                                                                            onChange={(e) => handleRenewableChange(i, 'selected', e.target.checked)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                    <td>{cat.name}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={cat.capacity}
                                                                            className="form-control-sm"
                                                                            onChange={(e) => handleRenewableChange(i, 'capacity', e.target.value)}
                                                                            disabled={true}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Total electricity consumption (kWh) - Financial year"
                                                    name="totalElectricConsumption"
                                                    placeholder=""
                                                    value={formInputs?.totalElectricConsumption || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.totalElectricConsumption}
                                                    disabled={true}
                                                />
                                            </Col>

                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Is there a Sewage treatment plant in the factory?"
                                                    >
                                                        Is there a Sewage treatment plant in the factory?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="sewageTreatment"
                                                        id="sewageTreatment"
                                                        checked={formInputs?.sewageTreatment === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.sewageTreatment === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs.sewageTreatment === true && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <ComboboxField
                                                            className="inputBox"
                                                            label="Select Sewage treatment Options"
                                                            name="sewageTreatmentOptions"
                                                            data={sewageTreatmentOptions}
                                                            placeholder=""
                                                            setValue={formInputs?.sewageTreatmentOptions || "Recycled and Reused in the Factory"}
                                                            onChange={onInputChange}
                                                            error={validation.sewageTreatmentOptions}
                                                            getvalue={setDropdownData}
                                                            required={true}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            {formInputs.sewageTreatment === false && (
                                                <>
                                                    <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={4}
                                                        className="commTopButtonRightLeftPadding"
                                                    >
                                                        <ComboboxField
                                                            className="inputBox"
                                                            label="Select Sewage treatment Options"
                                                            name="sewageTreatmentOptions"
                                                            data={sewageTreatmentOptionsFalse}
                                                            placeholder=""
                                                            setValue={formInputs?.sewageTreatmentOptions || ""}
                                                            onChange={onInputChange}
                                                            error={validation.sewageTreatmentOptions}
                                                            getvalue={setDropdownData}
                                                            required={true}
                                                            disabled={true}
                                                        />
                                                    </Col>
                                                </>
                                            )}
                                            {(formInputs.sewageTreatmentOptions === "Others" || formInputs.sewageTreatmentOptionsFalse === "Others") && (
                                                <Col
                                                    xs={12}
                                                    md={4}
                                                    lg={4}
                                                    className="commTopButtonRightLeftPadding"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        label="Others"
                                                        name="othersewageTreatment"
                                                        placeholder=""
                                                        value={formInputs.othersewageTreatment || ""}
                                                        onChange={onInputChange}
                                                        required={true}
                                                        error={validation.othersewageTreatment}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            )}
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Is there an Effluent treatment plant in the factory?"
                                                    >
                                                        Is there an Effluent treatment plant in the factory?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="treatmentPlant"
                                                        id="treatmentPlant"
                                                        checked={formInputs?.treatmentPlant === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.treatmentPlant === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Paper waste generated (Kg/Month)"
                                                    name="paperwasteQty"
                                                    placeholder=""
                                                    value={formInputs?.paperwasteQty || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.paperwasteQty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Poly Bag waste generated (Kg/Month)"
                                                    name="polyBagwasteQty"
                                                    placeholder=""
                                                    value={formInputs?.polyBagwasteQty || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.polyBagwasteQty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Carton Box waste generated (Kg/Month)"
                                                    name="cartonBoxwasteQty"
                                                    placeholder=""
                                                    value={formInputs?.cartonBoxwasteQty || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.cartonBoxwasteQty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Chindi Waste (Kg/Month)"
                                                    name="chindiWaste"
                                                    placeholder=""
                                                    value={formInputs?.chindiWaste || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.chindiWaste}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of e-waste generated (Kg/Year)"
                                                    name="eWaste"
                                                    placeholder=""
                                                    value={formInputs?.eWaste || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.eWaste}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Used oil generated (Liters/Month)"
                                                    name="usedOil"
                                                    placeholder=""
                                                    value={formInputs?.usedOil || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.usedOil}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Empty Chemical Conatiners generated (KG/Month)"
                                                    name="emptyChemicalQty"
                                                    placeholder=""
                                                    value={formInputs?.emptyChemicalQty || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.emptyChemicalQty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of ETP Sludge generated (KG/Month)"
                                                    name="etpSludgeQty"
                                                    placeholder=""
                                                    value={formInputs?.etpSludgeQty || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.etpSludgeQty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Carton Box waste generated (Kg/Month)"
                                                    name="cartonBoxWasteQty2"
                                                    placeholder=""
                                                    value={formInputs?.cartonBoxWasteQty2 || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.cartonBoxWasteQty2}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Chindi Waste (Kg/Month)"
                                                    name="chindiWaste2"
                                                    placeholder=""
                                                    value={formInputs?.chindiWaste2 || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.chindiWaste2}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Poly Bag waste generated (Kg/Month)"
                                                    name="polyBagWasteQty2"
                                                    placeholder=""
                                                    value={formInputs?.polyBagWasteQty2 || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.polyBagWasteQty2}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col
                                                xs={12}
                                                md={4}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding"
                                            >
                                                <InputField
                                                    className="inputBox"
                                                    label="Quantity of Paper waste generated (Kg/Month)"
                                                    name="paperwasteQty2"
                                                    placeholder=""
                                                    value={formInputs?.paperwasteQty2 || ""}
                                                    onChange={onInputChange}
                                                    required={true}
                                                    error={validation.paperwasteQty2}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="accordion mb-4" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <Row className="accordion-button">
                                        <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                                            <i
                                                className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                                                    }`}
                                                onClick={toggleCardVisibility2}
                                            ></i>
                                        </Col>
                                        <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                                            <span className="iconLogo">Es</span>
                                        </Col>
                                        <Col xs={8} md={8} lg={8}>
                                            <span className="headerTitle">Employee/Subcontarcing details</span>
                                            <span className="subHeaderTitle">Employee/Subcontarcing details</span>
                                        </Col>
                                    </Row>
                                </h2>
                                <div
                                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                                        }`}
                                >
                                    <div className="accordion-body">
                                        <Row className="pt-2 pb-4">
                                            <strong className="commTopButtonRightLeftPadding" >Sub-contracting Details</strong>
                                            <Col
                                                xs={12}
                                                md={3}
                                                lg={4}
                                                className="commTopButtonRightLeftPadding d-flex"
                                            >
                                                <div>
                                                    <label
                                                        className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                                                        htmlFor="Are any of the production processes subcontracted or outsourced outside of this factory?"
                                                    >
                                                        Are any of the production processes subcontracted or outsourced outside of this factory?{" "}
                                                    </label>
                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input custom-switch"
                                                        type="checkbox"
                                                        role="switch"
                                                        name="subContracted"
                                                        id="subContracted"
                                                        checked={formInputs?.subContracted === true}
                                                        onChange={onInputChange}
                                                        disabled={true}
                                                    />
                                                    <span>
                                                        {formInputs?.subContracted === true ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </Col>
                                            {formInputs?.subContracted === true && (
                                                <>
                                                    <Row>
                                                        <Col xs={12} md={2} lg={2}>
                                                            <p className="fs-6 fw-medium d-flex ms-4">
                                                                Sub Contracted Process
                                                            </p>
                                                        </Col>
                                                        <Col xs={12} md={2} lg={2}>
                                                            <p className="fs-6 fw-medium d-flex ms-4">
                                                                Facility Name
                                                            </p>
                                                        </Col>
                                                        <Col xs={12} md={2} lg={2}>
                                                            <p className="fs-6 fw-medium d-flex ms-4">
                                                                Full Address
                                                            </p>
                                                        </Col>
                                                        <Col xs={12} md={2} lg={2}>
                                                            <p className="fs-6 fw-medium d-flex ms-4">
                                                                Relationship
                                                            </p>
                                                        </Col>
                                                        <Col xs={12} md={2} lg={2}>
                                                            <p className="fs-6 fw-medium d-flex">
                                                                Action
                                                            </p>
                                                        </Col>
                                                        <Col xs={4} md={2} lg={2}>
                                                            <div className="d-flex justify-content-end  p-2 me-3">
                                                                <button
                                                                    className="btnTable"
                                                                    onClick={addUtilites}
                                                                >
                                                                    <i className="bi bi-plus-lg"></i> Add
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {getUtilites?.map(
                                                        (doc, index) => (
                                                            <Row key={doc.id}>
                                                                <Col xs={12}>
                                                                    <hr className="mx-4 my-0 text-color-black" />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={2}
                                                                    lg={2}
                                                                    className="commTopButtonRightLeftPadding"
                                                                >
                                                                    <InputField
                                                                        className="inputBox mt-1"
                                                                        name="subContractedProcess"
                                                                        placeholder="Sub Contracted Process
"
                                                                        value={doc.subContractedProcess || ""}
                                                                        onChange={(e) =>
                                                                            handleUtilites(
                                                                                doc.id,
                                                                                "subContractedProcess",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={2}
                                                                    lg={2}
                                                                    className="commTopButtonRightLeftPadding"
                                                                >
                                                                    <InputField
                                                                        className="inputBox mt-1"
                                                                        name="facilityName"
                                                                        placeholder="Facility Name"
                                                                        value={doc.facilityName || ""}
                                                                        onChange={(e) =>
                                                                            handleUtilites(
                                                                                doc.id,
                                                                                "facilityName",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={2}
                                                                    lg={2}
                                                                    className="commTopButtonRightLeftPadding"
                                                                >
                                                                    <InputField
                                                                        className="inputBox mt-1"
                                                                        name="fullAddress"
                                                                        placeholder="Full Address"
                                                                        value={doc.fullAddress || ""}
                                                                        onChange={(e) =>
                                                                            handleUtilites(
                                                                                doc.id,
                                                                                "fullAddress",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={2}
                                                                    lg={2}
                                                                    className="commTopButtonRightLeftPadding"
                                                                >
                                                                    <ComboboxField
                                                                        className="inputBox"
                                                                        name="relationShip"
                                                                        data={relationship}
                                                                        placeholder=""
                                                                        value={doc.relationShip || ""}
                                                                        onChange={(e) =>
                                                                            handleUtilites(
                                                                                doc.id,
                                                                                "relationShip",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        disabled={true}
                                                                    />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    md={1}
                                                                    lg={1}
                                                                    className="commTopButtonRightLeftPadding"
                                                                >
                                                                    <i
                                                                        onClick={() =>
                                                                            deleteUtilites(
                                                                                doc.id
                                                                            )
                                                                        }
                                                                        className="bi bi-trash text-danger fs-4"
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        ))}
                                                </>
                                            )}
                                        </Row>
                                        <Row>
                                            <strong className="commTopButtonRightLeftPadding">Employee Details</strong>
                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4"></p>
                                                </Col>
                                                <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Male</p>
                                                </Col>
                                                <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Female</p>
                                                </Col>
                                                <Col xs={12} md={2} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Total</p>
                                                </Col>
                                            </Row>
                                            {/* Permanent Coun */}
                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Permanent Employees</p>
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="permanentMaleCount"
                                                        placeholder=""
                                                        value={formInputs?.permanentMaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.permanentMaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="permanentFemaleCount"
                                                        placeholder=""
                                                        value={formInputs.permanentFemaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.permanentFemaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="totalPeramnentCount"
                                                        placeholder=""
                                                        value={formInputs.totalPeramnentCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.totalPeramnentCount}
                                                        disabled={true}

                                                    />
                                                </Col>
                                            </Row>

                                            {/* Contract */}
                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Contract Workers</p>
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="contractMaleCount"
                                                        placeholder=""
                                                        value={formInputs?.contractMaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.contractMaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="contractFemaleCount"
                                                        placeholder=""
                                                        value={formInputs.contractFemaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.contractFemaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="contractTotalCount"
                                                        placeholder=""
                                                        value={formInputs.contractTotalCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.contractTotalCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>
                                            {/* Piece */}
                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Piece Rate Workers</p>
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="pieceRateWorkerMaleCount"
                                                        placeholder=""
                                                        value={formInputs?.pieceRateWorkerMaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.pieceRateWorkerMaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="pieceRateWorkerFemaleCount"
                                                        placeholder=""
                                                        value={formInputs.pieceRateWorkerFemaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.pieceRateWorkerFemaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="pieceRateWorkerTotalCount"
                                                        placeholder=""
                                                        value={formInputs.pieceRateWorkerTotalCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.pieceRateWorkerTotalCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>
                                            {/* Probationary */}

                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Probationary</p>
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="probationaryMaleCount"
                                                        placeholder=""
                                                        value={formInputs?.probationaryMaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.probationaryMaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="probationaryFemaleCount"
                                                        placeholder=""
                                                        value={formInputs.probationaryFemaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.probationaryFemaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="probationaryTotalCount"
                                                        placeholder=""
                                                        value={formInputs.probationaryTotalCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.probationaryTotalCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>
                                            {/* Total Count */}
                                            <Row className="align-items-start">
                                                <Col xs={12} md={3} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">Total</p>
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="totalMaleCount"
                                                        placeholder=""
                                                        value={formInputs?.totalMaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.totalMaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="totalFemaleCount"
                                                        placeholder=""
                                                        value={formInputs.totalFemaleCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.totalFemaleCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                                <Col
                                                    xs={12}
                                                    md={2}
                                                    lg={2}
                                                    className="fs-3 d-flex ms-2"
                                                >
                                                    <InputField
                                                        className="inputBox"
                                                        name="totalCount"
                                                        placeholder=""
                                                        value={formInputs.totalCount || ""}
                                                        onChange={onInputChange}
                                                        error={validation.totalCount}
                                                        disabled={true}
                                                    />
                                                </Col>
                                            </Row>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <FailureModal
                show={getShowFailureModal}
                onHide={() => hideFailureModal()}
                failuremodaldata={getFailureModal}
                requiredfields={getErrorFields}
            />
            <FileViewerModal
                show={getShowFileViewModal}
                onHide={handleViewFileHide}
                fileid={getFileViewData}
            />
        </main>
    );
};
export default PreAssesmentForm;
